import type {Metric} from '../../lib/types';

export const isObservedReading=(source:string)=>source==='publisher.observed_reading'||source==='cap4publish.observed_reading';

// Keep the definition stable when a selected source has no observations.
// Search impressions and session duration are not article views or reading time.
export function articleSummary(metrics:Metric[]){
 const views=metrics.find(metric=>metric.source==='ga4'&&metric.key==='page_views')
  ||metrics.find(metric=>isObservedReading(metric.source)&&metric.key==='article_views');
 const reading=metrics.find(metric=>isObservedReading(metric.source)&&metric.key==='average_active_reading_seconds'&&metric.value!==null);
 return [{key:'views',label:'Visninger',metric:views},...(reading?[{key:'reading',label:'Gns. læsetid',metric:reading}]:[])];
}
